import type { IconData } from '@stacksjs/iconify-core'

export const contentBox: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M16 1H0v3h16zM6 5.5H1V15h14V5.5h-5V6a2 2 0 1 1-4 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default contentBox
